import script from "./Student.vue?vue&type=script&lang=ts&setup=true"
export * from "./Student.vue?vue&type=script&lang=ts&setup=true"

import "./Student.vue?vue&type=style&index=0&id=25b303f3&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b303f3"]])

export default __exports__